import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Tab,
  Tabs,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import PurchaseSection from "./components/PurchaseSection";
import IssueSection from "./components/IssueSection";
import ReturnSection from "./components/ReturnSection";
import SaleSection from "./components/SaleSection";
import AdjustmentSection from "./components/AdjustmentSection";
import TabPanel from "../../../components/TabPanel";
import { a11yProps } from "../../../utils/common";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const breadCrump = () => {
  return (
    <Breadcrumbs aria-label="Breadcrumb" mt={2}>
      <Typography>Inventory</Typography>
      <Typography>Stock Movement</Typography>
      <Typography>List</Typography>
    </Breadcrumbs>
  );
};

function StockMovementIndex() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card mb={6}>
        <CardHeader title="Stock Movement" subheader={breadCrump()} />
        <CardContent>
          <Box sx={{ mb: 4 }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="Stock Movement Tabs"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTabs-indicator": {
                  display: "none",
                },
                "& .MuiTabs-flexContainer": {
                  gap: "8px",
                },
                minHeight: "auto",
              }}
            >
              {["Opening Stock", "Purchase", "Issue Material", "Return Material", "Sale"].map(
                (label, idx) => (
                  <Tab
                    key={idx}
                    label={label}
                    {...a11yProps(idx)}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "0.875rem",
                      minHeight: "40px",
                      padding: "8px 16px",
                      borderRadius: "8px",
                      color: "text.secondary",
                      border: "1px solid",
                      borderColor: "divider",
                      "&.Mui-selected": {
                        backgroundColor: "primary.main",
                        color: "primary.contrastText",
                        borderColor: "primary.main",
                      },
                      "&:hover": {
                        backgroundColor: tabValue === idx ? "primary.main" : "action.hover",
                      },
                      transition: "all 0.2s ease",
                    }}
                  />
                ),
              )}
            </Tabs>
          </Box>

          <TabPanel value={tabValue} index={0}>
            <AdjustmentSection />
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <PurchaseSection />
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <IssueSection />
          </TabPanel>

          <TabPanel value={tabValue} index={3}>
            <ReturnSection />
          </TabPanel>

          <TabPanel value={tabValue} index={4}>
            <SaleSection />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
}

export default StockMovementIndex;
